import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TripCreationModalService {

  showTripCreationModal = signal(false);
  step = signal<'selectMethod' | 'basicInfo' | 'excelImport'>('selectMethod');
  mode = signal<'create' | 'edit'>('create');

  constructor() {}

  createTrip() {
    this.showTripCreationModal.set(true);
    this.step.set('selectMethod');
  }
  updateTrip() {
    this.showTripCreationModal.set(true);
    this.mode.set('edit');
    this.step.set('basicInfo');
  }
  close() {
    this.step.set('selectMethod');
    this.mode.set('create');
    this.showTripCreationModal.set(false);
  }
  createTripWithoutIA() {
    this.step.set('basicInfo');
  }
  goToExcelImport() {
    this.step.set('excelImport');
  }
}
